import { Text } from "@primer/react";
import { formatPercentage } from "../EditablePercentage/EditablePercentage.jsx";
import { PolicyIdentity } from "../PolicyIdentity/PolicyIdentity.jsx";
import "./PolicyFinding.css";

export function PolicyFinding({ document, href, policy, result, showIdentity = true }) {
  return <span className={`policy-finding ${result.status}${showIdentity ? "" : " without-identity"}`}>{showIdentity ? <PolicyIdentity document={document} href={href} policy={policy} size="small" /> : null}<Text>{relevantBoundary(policy, result)}</Text></span>;
}

function relevantBoundary(policy, result) {
  if (result.status === "non-compliant") return boundaryText(policy.must, result.basisPoints, "Must");
  if (result.status === "warning") return boundaryText(policy.should, result.basisPoints, "Should");
  if (result.status === "on-target") return "Within target range";
  return "Within required range";
}

function boundaryText(bounds, basisPoints, level) {
  if (bounds.minimum !== undefined && basisPoints < bounds.minimum) return `${level} be at least ${formatPercentage(bounds.minimum)}%`;
  return `${level} not exceed ${formatPercentage(bounds.maximum)}%`;
}
